/* Top of Mind — theme JS
   Idempotent: safe to run many times. Re-initializes on Shopify
   section load so the customizer never shows a "dead" section. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  /* ---------- measure fixed top bar height -> --topbar-h ---------- */
  function initOffsets() {
    var bar = document.getElementById('topbar');
    if (!bar) return;
    var h = bar.offsetHeight;
    if (h) document.documentElement.style.setProperty('--topbar-h', h + 'px');
    if (!window.__tomResizeBound) {
      window.__tomResizeBound = true;
      window.addEventListener('resize', function () {
        var b = document.getElementById('topbar');
        if (b && b.offsetHeight) document.documentElement.style.setProperty('--topbar-h', b.offsetHeight + 'px');
      }, { passive: true });
    }
    // re-measure after web fonts settle (line-heights can shift)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        var b = document.getElementById('topbar');
        if (b && b.offsetHeight) document.documentElement.style.setProperty('--topbar-h', b.offsetHeight + 'px');
      });
    }
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = document.getElementById('header');
    if (!header) return;
    function onScroll() {
      var h = document.getElementById('header');
      if (h) h.classList.toggle('scrolled', window.scrollY > 40);
    }
    onScroll();
    if (!window.__tomScrollBound) {
      window.__tomScrollBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* ---------- mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.getElementById('drawer');
    var burger = document.getElementById('burger');
    var close = document.getElementById('drawerClose');
    if (burger && drawer) burger.onclick = function () { drawer.classList.add('open'); };
    if (close && drawer) close.onclick = function () { drawer.classList.remove('open'); };
    if (drawer) drawer.querySelectorAll('[data-close]').forEach(function (a) {
      a.onclick = function () { drawer.classList.remove('open'); };
    });
  }

  /* ---------- announcement marquee (server-rendered wins) ---------- */
  function initMarquee() {
    var track = document.getElementById('marquee');
    if (!track || track.children.length) return;
    var msgs = [
      'Free shipping on U.S. orders $55+',
      'Representation is identity. Confidence is the catalyst.',
      'The Founding Circle is open — limited to 15',
      'Built from identity, in Orangeburg, SC'
    ];
    var seq = msgs.concat(msgs);
    track.innerHTML = seq.map(function (m) { return '<span>' + m + '</span>'; }).join('');
  }

  /* ---------- gold dust ---------- */
  function initDust() {
    var dust = document.getElementById('dust');
    if (!dust) return;
    if (reduce) { dust.innerHTML = ''; return; }
    var html = '';
    for (var i = 0; i < 46; i++) {
      var x = Math.random() * 100, y = Math.random() * 100,
        d = (Math.random() * 6).toFixed(2), s = (0.6 + Math.random() * 1.6).toFixed(2);
      html += '<i style="left:' + x + '%;top:' + y + '%;animation-delay:' + d + 's;transform:scale(' + s + ')"></i>';
    }
    dust.innerHTML = html;
  }

  /* ---------- hero cycler (single interval) ---------- */
  function initHero() {
    if (window.__tomHeroTimer) { clearInterval(window.__tomHeroTimer); window.__tomHeroTimer = null; }
    var cyc = document.getElementById('heroCyc');
    if (!cyc) return;
    var imgs = Array.prototype.slice.call(cyc.querySelectorAll('img'));
    if (imgs.length < 2) return;
    imgs.forEach(function (im, idx) { im.classList.toggle('on', idx === 0); });
    if (reduce) return;
    var speed = parseFloat(cyc.getAttribute('data-speed')) || 3.2;
    var i = 0;
    window.__tomHeroTimer = setInterval(function () {
      imgs[i].classList.remove('on');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('on');
    }, speed * 1000);
  }

  /* ---------- configurator data ---------- */
  var collections = {
    everyday: { name: 'The Standard', price: 55, colors: [
      { key: 'black', hex: '#1c1c1c', cw: 'Black Crown · White Globe · Black Brim' },
      { key: 'navy', hex: '#20304a', cw: 'Navy Crown · White Globe · Navy Brim' },
      { key: 'camel', hex: '#c08f56', cw: 'Camel Crown · Camel Globe · Camel Brim' },
      { key: 'green', hex: '#2f8f63', cw: 'Green Crown · Green Globe · Green Brim' }
    ] },
    move: { name: 'The Tempo', price: 55, colors: [
      { key: 'black', hex: '#1c1c1c', cw: 'Black Crown · White Globe · Black Brim' },
      { key: 'khaki', hex: '#b59f7d', cw: 'Light Khaki · White Globe · Khaki Brim' },
      { key: 'gray', hex: '#c2c4c6', cw: 'Light Gray · White Globe · Gray Brim' },
      { key: 'white', hex: '#f2f2ee', cw: 'White Crown · White Globe · White Brim' }
    ] },
    velvet: { name: 'The (SHE)EO', price: 215, colors: [
      { key: 'burgundy', hex: '#6e1f2c', cw: 'Burgundy Velvet · White Globe · Burgundy Brim' },
      { key: 'navy', hex: '#1f2c47', cw: 'Navy Velvet · White Globe · Navy Brim' },
      { key: 'emerald', hex: '#1f6b46', cw: 'Emerald Velvet · White Globe · Emerald Brim' },
      { key: 'carolina', hex: '#6f9fce', cw: 'Carolina Velvet · White Globe · Carolina Brim' }
    ] },
    florence: { name: 'The Florence', price: 525, colors: [
      { key: 'black', hex: '#1c1c1c', cw: 'Black Leather · Ostrich Brim' },
      { key: 'gray', hex: '#6b6e70', cw: 'Gray Leather · Ostrich Brim' },
      { key: 'navy', hex: '#20304a', cw: 'Navy Leather · Ostrich Brim' },
      { key: 'emerald', hex: '#1f6b46', cw: 'Emerald Leather · Ostrich Brim' }
    ] }
  };
  var order = ['everyday', 'move', 'velvet', 'florence'];

  function initConfigurator() {
    var elTabs = document.getElementById('cfgTabs');
    var elSwatches = document.getElementById('cfgSwatches');
    var elImgs = document.getElementById('cfgImgs');
    var elName = document.getElementById('cfgName');
    var elCw = document.getElementById('cfgCw');
    var elPrice = document.getElementById('cfgPrice');
    var elAddPrice = document.getElementById('cfgAddPrice');
    var elAdd = document.getElementById('cfgAdd');
    if (!elTabs || !elImgs || !elSwatches) return;

    var cfg = { col: 'everyday', idx: 0 };
    elImgs.innerHTML = '';            // clear (idempotent re-init)
    var imgMap = {};
    order.forEach(function (col) {
      collections[col].colors.forEach(function (c) {
        var im = document.createElement('img');
        im.src = (window.TOM_ASSETS && window.TOM_ASSETS[col + '-' + c.key]) || (col + '-' + c.key + '.jpg');
        im.alt = collections[col].name + ' ' + c.key;
        elImgs.appendChild(im);
        imgMap[col + '-' + c.key] = im;
      });
    });

    function renderTabs() {
      elTabs.innerHTML = '';
      order.forEach(function (col) {
        var b = document.createElement('button');
        b.className = 'config__tab' + (col === cfg.col ? ' active' : '');
        b.textContent = collections[col].name;
        b.onclick = function () { cfg.col = col; cfg.idx = 0; renderTabs(); renderSwatches(); update(); };
        elTabs.appendChild(b);
      });
    }
    function renderSwatches() {
      elSwatches.innerHTML = '';
      collections[cfg.col].colors.forEach(function (c, i) {
        var s = document.createElement('button');
        s.className = 'swatch' + (i === cfg.idx ? ' active' : '');
        s.style.background = c.hex;
        s.setAttribute('aria-label', c.cw);
        s.onclick = function () { cfg.idx = i; renderSwatches(); update(); };
        elSwatches.appendChild(s);
      });
    }
    function update() {
      var c = collections[cfg.col], col = c.colors[cfg.idx];
      for (var k in imgMap) imgMap[k].classList.remove('on');
      var a = imgMap[cfg.col + '-' + col.key];
      if (a) a.classList.add('on');
      if (elName) elName.textContent = c.name;
      if (elCw) elCw.textContent = col.cw;
      var coming = !!window.TOM_COMING_SOON;
      if (elPrice) elPrice.textContent = coming ? (window.TOM_COMING_LABEL || 'Coming Soon') : ('$' + c.price);
      if (elAddPrice) elAddPrice.textContent = coming ? '' : ('$' + c.price);
    }
    renderTabs(); renderSwatches(); update();
    if (elAdd) elAdd.onclick = function () { bag(collections[cfg.col].name + ' added'); };
  }

  /* ---------- cart + toast ---------- */
  function bag(label) {
    window.__tomCart = (window.__tomCart || 0) + 1;
    var cc = document.getElementById('cartCount');
    if (cc) cc.textContent = window.__tomCart;
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = label + ' ✦';
    toast.classList.add('show');
    clearTimeout(window.__tomToast);
    window.__tomToast = setTimeout(function () { toast.classList.remove('show'); }, 1900);
  }

  /* ---------- fit finder ---------- */
  function initFit() {
    var fitBtn = document.getElementById('fitBtn');
    var fitInput = document.getElementById('fitInput');
    var fitResult = document.getElementById('fitResult');
    var fitSize = document.getElementById('fitSize');
    if (!fitBtn || !fitInput) return;
    function rec() {
      var v = parseFloat(fitInput.value);
      if (isNaN(v) || v < 18 || v > 30) {
        if (fitSize) fitSize.textContent = 'Enter 18–30"';
        if (fitResult) fitResult.classList.add('show');
        return;
      }
      var size = 'Standard';
      if (v > 23.2) size = 'XXL'; else if (v >= 22.4) size = 'XL';
      if (fitSize) fitSize.textContent = size;
      if (fitResult) fitResult.classList.add('show');
    }
    fitBtn.onclick = rec;
    fitInput.onkeydown = function (e) { if (e.key === 'Enter') rec(); };
  }

  /* ---------- newsletter (front-end demo; real signup uses Shopify form) ---------- */
  function initNewsletter() {
    var newsBtn = document.getElementById('newsBtn');
    var newsEmail = document.getElementById('newsEmail');
    var newsNote = document.getElementById('newsNote');
    if (!newsBtn || !newsEmail) return;
    newsBtn.onclick = function () {
      var v = newsEmail.value.trim();
      if (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
        if (newsNote) newsNote.innerHTML = '<span class="news__ok">You\'re in. Check your inbox for 10% off ✦</span>';
        newsEmail.value = '';
      } else if (newsNote) {
        newsNote.textContent = 'Enter a valid email to claim 10% off.';
      }
    };
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (reduce || designMode()) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    if (window.__tomIO) window.__tomIO.disconnect();
    window.__tomIO = new IntersectionObserver(function (ent) {
      ent.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); window.__tomIO.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { if (!e.classList.contains('in')) window.__tomIO.observe(e); });
  }

  /* ---------- run ---------- */
  function initAll() {
    initOffsets(); initHeader(); initDrawer(); initMarquee(); initDust();
    initHero(); initConfigurator(); initFit(); initNewsletter(); initReveal();
  }
  ready(initAll);

  // Shopify theme editor: re-init when a section is added/edited/moved.
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function () {
    if (window.__tomHeroTimer) { clearInterval(window.__tomHeroTimer); window.__tomHeroTimer = null; }
  });
})();
